// Kid-friendly color palette - vibrant, saturated colors (will be lightened with CSS opacity)
const KID_FRIENDLY_COLORS = [
	'#FF0066', // Hot pink
	// '#F60000', // Red
	'#FF6633', // Red-orange
	// '#FF8C00', // Dark Orange
	// '#FFEE00', // Canary Yellow
	'#FFCC33', // Yellow
	'#4DE94C', // Screamin' Green
	'#0099CC', // Blue
	// '#3783FF', // Brilliant Azure
	'#7300FF', // Violet
	'#CC33CC', // Magenta
]

export class ColorUtils {
	private static colorCache = new Map<string, string>()

	/**
     * Get a consistent color for a word based on its text
     * Same word will always get the same color
     */
	static getColorForWord(wordText: string): string {
		// normalize
		wordText = wordText.toLowerCase().replace(/[^a-z]+/g, '')
		// Check cache first
		if (this.colorCache.has(wordText)) {
			return this.colorCache.get(wordText)!
		}

		// Generate a hash from the word text
		let hash = 0
		for (let i = 0; i < wordText.length; i++) {
			const char = wordText.charCodeAt(i)
			hash = ((hash << 5) - hash) + char
			hash = hash & hash // Convert to 32-bit integer
		}

		// Use absolute value and modulo to get color index
		const colorIndex = Math.abs(hash) % KID_FRIENDLY_COLORS.length
		const color = KID_FRIENDLY_COLORS[colorIndex]

		// Cache the result
		this.colorCache.set(wordText, color)

		return color
	}

	/**
     * Get a random color from the palette (for testing or variety)
     */
	static getRandomColor(): string {
		const randomIndex = Math.floor(Math.random() * KID_FRIENDLY_COLORS.length)
		return KID_FRIENDLY_COLORS[randomIndex]
	}

	/**
     * Clear the color cache (useful for testing)
     */
	static clearCache(): void {
		this.colorCache.clear()
	}
}
